import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { onError } from "../../../libs/errorLib";
import axiosInstance from "../../../axiosApi";
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Stack,
    TextField,
    Tooltip,
    Alert,
    Grid
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { ControlInputText } from "../../../components/ControlInputText";
import { ControlInputTextMenuItem } from "../../../components/ControlInputTextMenuItem";
import { IconContext } from "react-icons";
import { FaCloudDownloadAlt, FaCamera } from "react-icons/fa";

//example of creating a mui dialog modal for creating new rows
const UseCaseTableCreate = ({ columns, setUpdateState }) => {
    const { register, handleSubmit, formState, getValues, setValue, control } = useForm();
    const [isLoading, setIsLoading] = useState(true);
    const { isSubmitting } = formState;
    const { t } = useTranslation();

    const onChangeBillingForm = () => {
        const regex = /^[0-9\b -]{0,13}$/;
        //var f_data = getValues()
        //columns.map((column) => console.log(column.accessorKey));
        //console.log(f_data);
        // if (f_data.startdate){
        //     console.log(dateFns.format(f_data.startdate,"yyyy-MM-dd"));
        //     //setValue("startdate", dateFns.format(f_data.startdate,"yyyy-MM-dd"))
        // }
        // if (f_data.enddate){
        //     console.log(dateFns.format(f_data.enddate,"yyyy-MM-dd"));
        //     //setValue("enddate", dateFns.format(f_data.enddate,"yyyy-MM-dd"))
        // }
        // if (f_data.expiry){
        //     setValue("expiry", f_data.expiry.replace(/-/g, '').replace(/(\d{4})(\d{2})/, '$1-$2'))
        // }
        return;
    }

    const onSubmit = (data) => {
        console.log(data);
        setIsLoading(true);

        axiosInstance.post(`/raxigo/hbmaster/`, {
            name_category: data.name_category,
            code_hb: data.code_hb,
            name_hb: data.name_hb,
            code_hz: data.code_hz,
            name_hz: data.name_hz,
            code_fn: data.code_fn,
            name_fn: data.name_fn,
            element_sensor: data.element_sensor
        }).then(function (response) {
            if (typeof response === 'undefined') throw "에러처리루틴 완료";
            setUpdateState(new Date());
        }).catch(function (error) {
            //console.log(error);

            setIsLoading(false);
        });
    };

    return (
        <>
            <Stack
                sx={{
                    width: '100%',
                    minWidth: { xs: '260px', sm: '300px', md: '400px' },
                    gap: '1.5rem',
                    border: 2,
                    padding: 0.5,
                    marginTop: 3,
                    marginBottom: 3
                }}
            >
                {(!formState.isValid && formState.isSubmitted) ?
                    <Alert severity="error"   >
                        {Object.values(formState.errors).map((e, idx) => {
                            return (<p key={idx}>{e.message}</p>)
                        })}
                    </Alert>
                    :
                    <Alert severity="success">범부별로 Hazardous Behavior, Hazard, Funtion, Element 를 입력해 주세요</Alert>
                }
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        {columns.map((column) => {
                            if (column.accessorKey == 'name_category') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "범주를 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            } else if (column.accessorKey == 'code_hb') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "Hazardous Behavior 을 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            } else if (column.accessorKey == 'name_hb') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "Hazardous Behavior 명 을 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            } else if (column.accessorKey == 'code_hz') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "Hazard 을 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            } else if (column.accessorKey == 'name_hz') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "Hazard명 을 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            } else if (column.accessorKey == 'code_fn') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "기능 을 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            } else if (column.accessorKey == 'name_fn') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "기능명 을 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            } else if (column.accessorKey == 'element_sensor') {
                                return (
                                    <Grid item xs={12} md={3}>
                                        <ControlInputText
                                            name={column.accessorKey}
                                            type="text"
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: "관련센서 을 입력해 주세요"
                                                },
                                                onChange: () => { onChangeBillingForm() }
                                            }}
                                            label={column.header}
                                            defaultValue=""
                                        />
                                    </Grid>
                                );
                            }

                        })}

                        <Grid item xs={12} md={6}>
                            <DialogActions sx={{ p: '1.25rem' }}>
                                <Button color="secondary" type="submit" variant="contained">
                                    Hazardous Behavior 등록
                                </Button>
                            </DialogActions>
                        </Grid>

                    </Grid>
                </form>
            </Stack>
        </>
    );
};

export default UseCaseTableCreate;